import { filterFormEntries } from '@contracts/order/FormEntriesFilter';
import { sanitizeEditOrderInputs } from '@src/orders/schemas/SanitizeEditOrderInputs';
import { OrdersClient } from '@src/orders/services/OrdersClient';
import { useMutation } from '@tanstack/react-query';

export const useUpdateOrderAsDraft = ({
  orderId,
  onSuccess,
  onError,
}: {
  orderId: string;
  onSuccess: () => void;
  onError: () => void;
}) => {
  const { mutate, isPending } = useMutation<
    void,
    Error,
    { data: Record<string, unknown>; fields?: string[] }
  >({
    mutationFn: async ({ data, fields }): Promise<void> => {
      const sanitized = sanitizeEditOrderInputs(data);
      const filtered = fields
        ? filterFormEntries(sanitized, fields)
        : sanitized;
      await OrdersClient.updateAsDraft(orderId, filtered);
    },
    onSuccess,
    onError,
  });

  return {
    updateOrderAsDraft: mutate,
    isPending,
  };
};
